import React from 'react';

import styled, { css } from 'styled-components';
import { FlexContainer } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

import { Typography8 } from './Typography';

export default function NumberRating({
  onSelect,
  data,
  selectedId,
  descriptionKey = 'id',
  error = false,
  readOnly = false,
  size = 'medium',
}) {
  const handleChange = (item) => {
    if (!readOnly) onSelect && onSelect(item.id);
  };
  const descriptionText1 = data[0]?.description;
  const descriptionText2 = data[data.length - 1]?.description;
  return (
    <FlexContainer style={{ flexDirection: 'column', alignItems: 'center', flex: '1 1 0' }}>
      <Scale error={error} readOnly={readOnly}>
        {data.map((item, index) => (
          <ScaleTile onClick={() => handleChange(item)} active={item.id === selectedId}>
            {item[descriptionKey]}
          </ScaleTile>
        ))}
      </Scale>
      {!!descriptionText1 && !!descriptionText2 && (
        <FlexContainer style={{ justifyContent: 'space-between', paddingTop: '16px', width: '100%' }}>
          <Typography8>{descriptionText1}</Typography8>
          <Typography8>{descriptionText2}</Typography8>
        </FlexContainer>
      )}
    </FlexContainer>
  );
}

const Scale = styled.div`
  ${(props) => `border: 1px solid ${getColorFromKey(props.error ? 'red' : 'lightGrey')};`}
  border-radius: 4px;
  width: 100%;
  display: flex;

  margin-top: 0.5rem;
  ${(props) =>
    props.readOnly &&
    `
    pointer-events: none;
  `}
`;

const ScaleTile = styled.span`
  ${(props) =>
    props.active &&
    css`
      background: ${getColorFromKey('primary')};
      color: white;
    `}
  flex: 1 1 0;
  padding: 12px 8px;
  border-right: 1px solid #eaeaea;
  line-height: 36px;
  &:last-child {
    border-right: none;
  }
  text-align: center;
  ${(props) =>
    !props.active &&
    css`
      &:hover {
        background: ${(props) => props.theme.palette.background.blue.light.v2};
      }
    `}
  cursor: pointer;
`;
